import { render } from "./FamiliaNueva.vue?vue&type=template&id=6c5b145a&ts=true"
import script from "./FamiliaNueva.vue?vue&type=script&lang=ts"
export * from "./FamiliaNueva.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__